module.exports = __webpack_public_path__ + "img/no-data.79b98a5a.png";